export default "__VITE_ASSET__D_ld47oh__"